import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetSupports } from "../../store/actions/user-action";
import SupportTableComponent from "../../components/SupportTable/SupportTable";

const FeedbackPage = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(GetSupports({ supports: "suggestion" }));
    }, 1000);

    return () => clearTimeout(timer); // Cleanup the timer
  }, [dispatch]);

  // Access 'supportDetails' from the correct part of the Redux state
  const { supportDetails } = useSelector((state) => state.supportDetails || {});

  const getDataForSupportType = () => {
    return Array.isArray(supportDetails) ? supportDetails : []; // Return data from Redux store
  };

  return (
    <div className="p-[25px] rounded-md border-[solid] border bg-white">
      <h3 className="font-medium">Feedback</h3>
      <p className="text-sm text-[#595858] mt-2">
        In publishing and graphic design, Lorem ipsum is a placeholder text
        commonly used to demonstrate the visual form of a document or a typeface
        without relying on meaningful content.
      </p>
      <SupportTableComponent data={getDataForSupportType()} page={"feedback"} />
    </div>
  );
};

export default FeedbackPage;
